import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Dispatcher, Language } from "../../../../../../../../../../services";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";
import { getRoleDisplayName } from "../../../../../../../../../../assets/languages/langs";

const RoleCellContent: React.FC<RoleCellContent.Props> = ({ item }) => {
	const { i18n } = useTranslation();

	const content = useMemo(
		() =>
			item.roles
				?.map((role) =>
					getRoleDisplayName(role.name, i18n.language as Language),
				)
				?.filter(Boolean)
				?.join(", ") ?? "",
		[item?.roles, i18n.language],
	);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace RoleCellContent {
	interface Props {
		item: Dispatcher.Model;
	}
}

export default RoleCellContent;
